import React from 'react'
import { useSanity } from 'store/sanity'

export default () => {    
  useSanity()
  return <></>
}